import qs from 'qs';
import { join, capitalize, startCase } from "lodash";
import {PropertyDetailsURL, PropertySearchURL, defaultArea, defaultArea_Slug, defaultArea_Newhomes, defaultArea_Newhomes_Slug, currency, site_bviewing_agent_id} from "../constant"
import {currencyFormat, removeSpecialChar, toCapitalize} from "./site_utlis"


const METER_VAL = 1609.34

export const meterToMiles = (val) => {
  return Math.round(parseFloat(val) / METER_VAL)
}

export const milesToMeter = (val) => {
  return Math.round(parseFloat(val) * METER_VAL)
}

export const getAgentId = (office_crm_id) => {
    var agent_id = site_bviewing_agent_id;

    let glasgow_crmid = "DJG,MUA,DJK,DJX,DJU"
    let edinburgh_crmid = "DJC,MNG,DJD,DJA,DJH,DJW,DJT,DHO"
    let dun_crmid = "DUN,DSA"

    let aberdeen_crmid = "SLA,SLK,DAA"

    let manchester_crmid = "STY"

    if(office_crm_id){
        if(dun_crmid.indexOf(office_crm_id) > -1){
            agent_id = "RFR-DJAlexanderDundee";
        }
        if(glasgow_crmid.indexOf(office_crm_id) > -1){
            agent_id = "RFR-DJAlexanderGlasgow";
        }
        if(edinburgh_crmid.indexOf(office_crm_id) > -1){
            agent_id = "RFR-DJAlexanderEdinburgh"
        }
        if(aberdeen_crmid.indexOf(office_crm_id) > -1){
            agent_id = "RFR-DJAlexanderAberdeen"
        }
        if(manchester_crmid.indexOf(office_crm_id) > -1){
            agent_id = "RFR-ThornleyGrovesManchesterCentral"
        }
    }

    return agent_id;
}


export const propertyDetailUrl = (department, search_type, status, slug, id) => {

    //console.log("department==>", department, search_type, status, slug, id)
    var prop_slug_id = slug+"-"+id+"/"
    var property_url = PropertyDetailsURL[department][search_type]+prop_slug_id;
    return property_url;
}

export const PropertySearchUrl = (department, search_type, status) => {
    var property_url = PropertySearchURL[department][search_type];
    return property_url;
}

export const GetPrice = (price) => {
    var price_format = currency+"0";
    if(parseInt(price) > 0){
        price_format = currency+""+parseInt(price).toLocaleString();
    }
    
    return price_format;
}

export const getBedValue = (val) => {
    let bedVal = '';
    if (parseInt(val) > 1) {
        bedVal = val + " beds"
    } else{
        bedVal = val + " bed"
    }
    return bedVal;
}

export const getPriceStr = (min, max) => {
    let priceStr = '';
    if (min && max) {
      priceStr = `between ${GetPrice(min)} and ${GetPrice(max)}`;
    } else if (max) {
      priceStr = `below ${GetPrice(max)}`;
    } else if (min) {
      priceStr = `above ${GetPrice(min)}`;
    }
    return priceStr;
}

export const getBedStr = (min, max) => {
    let bedStr = '';
    if (min && max) {
        bedStr = `with ${min} to ${max} bedrooms`;
    } else if (max) {
        bedStr = `with less than ${max} bedrooms`;
    } else if (min) {
        let bed_text = "bedroom"
        if(parseInt(min) > 1){
            bed_text = "bedrooms"
        }
        bedStr = `with more than ${min} ${bed_text}`;
    }
    return bedStr;
}

export const getPriceUrl = (min, max) => {
    let priceStr = '';
    if (min && max) {
      priceStr = `between-${currencyFormat(min)}-and-${currencyFormat(max)}/`;
    } else if (max) {
      priceStr = `below-${currencyFormat(max)}/`;
    } else if (min) {
      priceStr = `above-${currencyFormat(min)}/`;
    }
    return priceStr;
}

export const getBedUrl = (bed_val) => {
    let bed_url = '';
    if(parseInt(bed_val) === 0){
        bed_url = 'studio/';
    } else{
        bed_url = bed_val + "-and-more-bedrooms/";
    }
    return bed_url;
}

export const Sortindex = {
    newest: "_newest",
    oldest: "_oldest",
    highestprice: "_price_desc",
    lowestprice: "_price_asc"
}

export const ExcludeVal = {
    sale_agreed: "For Sale",
    let_agreed: "To Let",
}

//Miles Distance
export const MilesDistance = [
    { label: "This area only", value: "0" },
    { label: "+1 mile", value: "1" },
    { label: "+3 miles", value: "3" },
    { label: "+5 miles", value: "5" },
    { label: "+10 miles", value: "10" },
    { label: "+15 miles", value: "15" },
    { label: "+20 miles", value: "20" },
    { label: "+30 miles", value: "30" },
    { label: "+40 miles", value: "40" },
]

//Miles Distance
export const AmenitiesOptions = [
    { name: "Garden", slug: "garden" },
    { name: "Parking", slug: "parking" },
    { name: "Balcony/Terrace", slug: "balcony-terrace" },
]

// Create URL
export const searchStateToUrl = (index_name, state, location, grid_view, screen_wdth) => {

    //console.log("state ==>",state);

    const isDefaultRoute =
        !state.query &&
        !state.sortBy &&
        state.page === 1 &&
        state.menu &&
        state.range &&
        !state.range.price &&
        !state.range.bedroom && 
        (
            state.refinementList &&
            !state.refinementList?.mustInclude &&
            !state.refinementList?.mustInclude?.length === 0
        )
        (
            state.refinementList &&
            !state.refinementList?.furnishing
        )
        (
            state.refinementList &&
            !state.refinementList?.office_crm_id
        )
        (
            state.refinementList &&
            !state.refinementList?.radiusVal
        )
        (
            state.refinementList &&
            !state.refinementList?.exclude_val
        )

        
    if (isDefaultRoute) {
        return ""
    }

    var areaPath = "in-" + defaultArea_Slug + "/"
    var bedroomPath = ""
    var pricePath = ""
    var pagePath = ""
    var propertypath = ""
    var sortPath = ""
    var mustincludePath = ""
    var furnishPath = ""
    var branchPath = ""
    let radiusPath = ""
    let excludePath = ""

    //console.log("state ==>", state);


    if (state.query) {
        areaPath = "in-" + encodeURIComponent(decodeURIComponent(removeSpecialChar(state.query))) + "/"
    } 

    // Property path
    if (state.menu) {
        //console.log("building==>", state?.menu?.building, typeof state?.menu?.building)
        if (typeof state?.menu?.building === "object") {
            if (state.menu.building.length > 0) {
                var building_list = state.menu.building.filter(
                    function (item, index, inputArray) {
                        return inputArray.indexOf(item) == index
                    }
                )
                if (building_list.length > 0) {
                    propertypath = `type-${building_list
                    .map(encodeURIComponent)
                    .join("-and-")}/`
                }
            }
        } else{
            if (state?.menu?.building) {
                propertypath = "type-" + state.menu["building"].replace(/ /g, '-') + "/"
            }
        }

    }
    // Property path

    // Bedrooms & Price range path
    if (state.range) {
        // Bedrooms 
        if (state.range.bedroom) {
        //console.log('search ==> bedroom', state.range.bedroom)

            // if (parseInt(state.range.bedroom.min) === 0) {
            //     bedroomPath = "studio/"
            // }

            // if (state.range.bedroom?.plus) {
            //     if (state.range.bedroom?.plus === "true") {
            //         if (parseInt(state.range.bedroom.min) > 0) {
            //             bedroomPath = state.range.bedroom.min + "-and-more-bedrooms/"
            //         }
            //     } else{
            //         if (parseInt(state.range.bedroom.min) > 0) {
            //             if (parseInt(state.range.bedroom.min) > 1) {
            //                 bedroomPath = state.range.bedroom.min + "-bedrooms/"
            //             } else{
            //                 bedroomPath = state.range.bedroom.min + "-bedroom/"
            //             }
            //         }
            //     }
            // } else{
            //     if (parseInt(state.range.bedroom.min) > 0) {
            //         bedroomPath = state.range.bedroom.min + "-and-more-bedrooms/"
            //     }
            // }

            if (state.range.bedroom.min && state.range.bedroom.max) {
                bedroomPath = "from-" + state.range.bedroom.min + "-to-" + state.range.bedroom.max + '-bedrooms/';
            } else if (state.range.bedroom.max) {
                bedroomPath = "under-" + state.range.bedroom.max + '-bedrooms/';
            } else if (state.range.bedroom.min) {
                bedroomPath = "more-than-" + state.range.bedroom.min + '-bedrooms/';
            }
        }

        // Price
        if (state.range.price) {
            if (state.range.price.min && state.range.price.max) {
                pricePath = "between-" + state.range.price.min + "-and-" + state.range.price.max + '/';
            } else if (state.range.price.max) {
                pricePath = "below-" + state.range.price.max + '/';
            } else if (state.range.price.min) {
                pricePath = "above-" + state.range.price.min + '/';
            }
        }
    }
    // Bedrooms & Price range path

    // Mustinclude path
    if (state.refinementList) {
        if (typeof state.refinementList.mustInclude === "object") {
            if (state.refinementList.mustInclude.length > 0) {
                var mustInclude_list = state.refinementList.mustInclude.filter(
                    function (item, index, inputArray) {
                        return inputArray.indexOf(item) == index
                    }
                )
                if (mustInclude_list.length > 0) {
                    mustincludePath = `with-${mustInclude_list
                    .map(encodeURIComponent)
                    .join("-and-")}/`
                }
            }
        } else {
            if (state.refinementList.mustInclude) {
                mustincludePath = `with-${state.refinementList.mustInclude}/`
            }
        }


        if (state.refinementList?.furnishing) {
            furnishPath = `furnishing-${state.refinementList?.furnishing}/`
        }

        if (state.refinementList?.office_crm_id) {
            branchPath = `branch-${state.refinementList?.office_crm_id}/`
        }

        if (state.refinementList?.radiusVal) {
            if (state.query) {
                if (state.refinementList?.radiusVal) {
                  radiusPath = `radius-${state.refinementList?.radiusVal.replace(/ /g, "-")}/`
                }
            }
        }

        if (state.refinementList?.exclude_val) {
            excludePath = `exclude-${state.refinementList?.exclude_val}/`
        }
    }
    // Mustinclude path

    // Sort path
    if (state.sortBy) {
        if (state.sortBy === index_name + "_price_asc") {
            sortPath = "sortby-price-asc/";
        }
        if (state.sortBy === index_name + "_price_desc") {
            sortPath = "sortby-price-desc/";
        }
        if (state.sortBy === index_name + "_newest") {
            sortPath = "sortby-newest/";
        }
        if (state.sortBy === index_name + "_oldest") {
            sortPath = "sortby-oldest/";
        }
    }
    // Sort path

    // Page path
    if(screen_wdth > 1200){
        if (state.page && state.page !== 1) {
            pagePath = `page-${state.page}/`
        }
    } else{
        if(grid_view){
            pagePath = "";
        } else{
            if (state.page && state.page !== 1) {
                pagePath = `page-${state.page}/`
            }
        }
    }
    
    // Page path 


    let myUrl = `${areaPath}${propertypath}${bedroomPath}${pricePath}${mustincludePath}${furnishPath}${branchPath}${radiusPath}${excludePath}${pagePath}${sortPath}`;

    // console.log("loc ==> 1 ", `${location}${myUrl}`)

    if ("/" !== myUrl.substr(myUrl.length - 1))
        myUrl = myUrl.substr(0, myUrl.length - 1)

    //console.log("loc ==> 2", `${location}${myUrl}`)

    return `${location}${myUrl}`
}
// Create URL


// URL to searchstate 
export const urlToSearchState = (index_name, location) => {
    if (location) {
        //console.log("location ==> 2",location);

        var query = ""
        let pathUri_main = ''

        let a1 = location.pathname.indexOf("/property/for-sale") > -1
        let a2 = location.pathname.indexOf("/property/to-rent") > -1
        let a3 = location.pathname.indexOf("/new-developments/for-sale") > -1
        let a4 = location.pathname.indexOf("/commercial-property/for-sale") > -1
        let a5 = location.pathname.indexOf("/commercial-property/to-rent") > -1
        let a6 = location.pathname.indexOf("/property-collection/for-sale") > -1
        let a7 = location.pathname.indexOf("/property-students/to-rent") > -1
        let a8 = location.pathname.indexOf("/property-exceptional/for-sale") > -1

        if (a1 == true) {
            pathUri_main = location.pathname.split("/property/for-sale")
        }
        else if (a2 == true) {
            pathUri_main = location.pathname.split("/property/to-rent")
        } else if (a3 == true) {
            pathUri_main = location.pathname.split("/new-developments/for-sale")
        }
        else if (a4 == true) {
            pathUri_main = location.pathname.split("/commercial-property/for-sale")
        }
        else if (a5 == true) {
            pathUri_main = location.pathname.split("/commercial-property/to-rent")
        }
        else if (a6 == true) {
            pathUri_main = location.pathname.split("/property-collection/for-sale")
        }
        else if (a7 == true) {
            pathUri_main = location.pathname.split("/property-students/to-rent")
        }
        else if (a8 == true) {
            pathUri_main = location.pathname.split("/property-exceptional/for-sale")
        }
        else {
            pathUri_main = location.pathname.split(location)
        }

        var areaVal = ""
        var bedVal = 10
        var minpriceVal = ""
        var maxpriceVal = ""
        var pageVal = ""
        var propertyval = ""
        var sortVal = ""
        var sortVal_filt = ""
        var mustincludeVal = ""
        var furnishVal = ""
        var branchVal = ""
        var excludeVal = ""

        if (pathUri_main[1]) {
        // following could be regexp
        let pathUri = pathUri_main[1].split("/")
        //lets loop
        for (let vi = 1; vi <= pathUri.length; vi++) {
            // check for area
            if (typeof pathUri[vi] === "undefined") {
            continue
            }

            // Property type
            if (pathUri[vi].indexOf("type-") >= 0) {
            propertyval = pathUri[vi].replace("type-", "")
            }

            // Area
            if (pathUri[vi].indexOf("in-") >= 0) {
                areaVal = removeSpecialChar(pathUri[vi].replace("in-", ""), " ")
            }
            // Price
            if (
            pathUri[vi].indexOf("between-") >= 0 ||
            pathUri[vi].indexOf("above-") >= 0 ||
            pathUri[vi].indexOf("below-") >= 0
            ) {
            let priceFilt1 = pathUri[vi].split("above-")
            if (priceFilt1[1]) {
                minpriceVal = priceFilt1[1]
            }
            let priceFilt2 = pathUri[vi].split("below-")
            if (priceFilt2[1]) {
                maxpriceVal = priceFilt2[1]
            }
            let priceFilt3 = pathUri[vi].split("between-")
            if (priceFilt3[1]) {
                let priceFilt4 = priceFilt3[1].split("-and-")
                minpriceVal = priceFilt4[0]
                maxpriceVal = priceFilt4[1]
            }
            }

            // Bedrooms
            // if (pathUri[vi].indexOf("-and-more-") >= 0) {
            if (pathUri[vi].indexOf("-bedrooms") >= 0) {
                bedVal = pathUri[vi].replace("-and-more-bedrooms", "").replace("-bedrooms", "")
            }

            if (pathUri[vi].indexOf("studio") >= 0) {
                // its studio bedroom
                bedVal = 0
            }

            //console.log("bedVal==>", bedVal);


            // Sort by
            if (pathUri[vi].indexOf("sortby-") >= 0) {
                sortVal_filt = pathUri[vi].replace("sortby-", "")

                sortVal = index_name;
                if (sortVal_filt === "price-asc") {
                    sortVal = index_name + "_price_asc"
                }

                if (sortVal_filt === "price-desc") {
                    sortVal = index_name + "_price_desc"
                }

                if (sortVal_filt === "newest") {
                    sortVal = index_name + "_newest"
                }
                if (sortVal_filt === "oldest") {
                    sortVal = index_name + "_oldest"
                }
            }

            // Mustinclude
            if (pathUri[vi].indexOf("with-") >= 0) {
                //mustincludeVal = pathUri[vi].replace("with-", "")
                var mustincludeArrfilt = pathUri[vi].replace("with-", "")
                mustincludeVal = mustincludeArrfilt.split("-and-")
            }

            // Furnishing Val
            if (pathUri[vi].indexOf("furnishing-") >= 0) {
                furnishVal = pathUri[vi].replace("furnishing-", "")
            }

            // Branch Val
            if (pathUri[vi].indexOf("branch-") >= 0) {
                branchVal = pathUri[vi].replace("branch-", "")
            }

            // Exclude Val
            if (pathUri[vi].indexOf("exclude-") >= 0) {
                excludeVal = pathUri[vi].replace("exclude-", "")
            }

            // Page
            if (pathUri[vi].indexOf("page") >= 0) {
                pageVal = pathUri[vi].replace("page-", "")
            }
        }
        }
    }

    // Property type
    if (propertyval) {
        query += `&menu[building]=${propertyval}`
    }

    // Area
    if (areaVal) {
        areaVal = areaVal.toLowerCase();

        var areaVal_url = areaVal.replace(/ /g, '-')
        //console.log("defaultArea_Slug", defaultArea_Slug, areaVal_url, areaVal)

        if(areaVal.length < 5) {
            areaVal = '"'+areaVal+'"'
            //areaVal = areaVal
        }

        if(areaVal_url === defaultArea_Slug || areaVal_url === defaultArea_Newhomes_Slug){
            query += `&query=`
        } else{
            query += `&query=${areaVal}`
        }
        
    }

    // Price
    if (minpriceVal) {
        query += `&range[price][min]=${minpriceVal}`;
    }

    if (maxpriceVal) {
        query += `&range[price][max]=${maxpriceVal}`;
    }

    // Bedrooms
    if (bedVal === 0) {
        query += `&range[bedroom][min]=` + 0
        query += `&range[bedroom][max]=` + 0
    } else if (bedVal < 10) {
        query += `&range[bedroom][min]=${bedVal}`
    }

    // Mustinclude
    if (mustincludeVal?.length > 0) {
        //query += `&refinementList[mustInclude]=` + mustincludeVal
        for (let v = 0; v <= mustincludeVal.length; v++) {
        if (typeof mustincludeVal[v] !== "undefined") {
            query += `&refinementList[mustInclude]=` + mustincludeVal[v]
        }
        }
    }

    // Furnishing type
    if (furnishVal) {
        query += `&refinementList[furnishing]=${furnishVal}`
    }

    // Branch Value
    if (branchVal) {
        query += `&refinementList[office_crm_id]=${branchVal}`
    }


    // if(location?.state?.prestige_property === true){
    //     query += `&refinementList[officeDepartment]=Prestige`
    // }

    // Page
    if (pageVal) {
        query += `&page=${pageVal}`
    }

    // Sort by
    if (sortVal) {
        query += `&sortBy=${sortVal}`
    }

    return qs.parse(query)
}
// URL to searchstate


// Search Params
export const propertySearchParams = (search) => {
    var actionIn = "for sale";
    var type = "sales"
    var office_department = ""
    var my_page_url_data = search?.my_page_url_data;

    if (search.path === "/property/to-rent/") {
        actionIn = "to rent"
        type = "lettings"
    } else if (search.path === "/commercial-property/to-rent/") {
        actionIn = "to rent"
        type = "lettings"
    } else if (search.path === "/new-developments/for-sale/") {
        type = "newdevelopments"
    } else if (search.path === "/property-collection/for-sale/") {
        office_department = "collection"
    } else if (search.path === "/property-exceptional/for-sale/") {
        office_department = "exceptional"
    } else if (search.path === "/property-students/to-rent/") {
        actionIn = "for rent"
        type = "lettings"
        office_department = "student"
    }
    else if (search.path === "/new-homes/for-sale/") {
        actionIn = "for sale"
        type = "sales"
        office_department = "new_homes"
    }
    else if (search.path === "/auctions/for-sale/") {
        actionIn = "for sale"
        type = "sales"
    }


    var must_include_arr = [];
    
    if(my_page_url_data?.mustincludeVal){
        if(typeof my_page_url_data?.mustincludeVal === "object"){
            if(my_page_url_data?.mustincludeVal.length > 0){
                must_include_arr = my_page_url_data?.mustincludeVal
            }
        } else{
            must_include_arr = [my_page_url_data?.mustincludeVal]
        }  
    }

    var propertytype_arr = [];
    
    if(my_page_url_data?.propertyTypeVal){
        if(typeof my_page_url_data?.propertyTypeVal === "object"){
            if(my_page_url_data?.propertyTypeVal.length > 0){
                propertytype_arr = my_page_url_data?.propertyTypeVal
            }
        } else{
            propertytype_arr = [my_page_url_data?.propertyTypeVal]
        }  
    }


    return {
        propertyType: my_page_url_data?.buildingval ? my_page_url_data?.buildingval : null,
        propertyTypeArr: propertytype_arr?.length > 0 ? propertytype_arr: [],
        type: type,
        defaultArea: type === "newdevelopments" ? defaultArea_Newhomes : defaultArea,
        defaultArea_Slug: type === "newdevelopments" ? defaultArea_Newhomes_Slug : defaultArea_Slug,
        search_type: type ? type : "sales",
        department: search?.department ? search?.department : "residential",
        areas: (search?.searchState?.query) ? search?.searchState?.query : my_page_url_data?.areaVal ? my_page_url_data?.areaVal : defaultArea,
        //areas: my_page_url_data?.areaVal,
        action: actionIn,
        minPrice: (my_page_url_data?.minpriceVal) ? my_page_url_data?.minpriceVal : null,
        maxPrice: (my_page_url_data?.maxpriceVal) ? my_page_url_data?.maxpriceVal : null,
        bedrooms: search?.department === "residential" ? ((my_page_url_data?.bedVal) ? my_page_url_data?.bedVal : null) : null,
        bedValPlus: search?.department === "residential" ? ((my_page_url_data?.bedValPlus) ? my_page_url_data?.bedValPlus : "true") : null,
        minbedVal: (my_page_url_data?.minbedVal) ? my_page_url_data?.minbedVal : null,
        maxbedVal: (my_page_url_data?.maxbedVal) ? my_page_url_data?.maxbedVal : null,
        mustInclude: (must_include_arr.length > 0) ? must_include_arr : [],
        furnishing: my_page_url_data?.furnishVal ? my_page_url_data?.furnishVal : "",
        office_department: office_department,
        sortBy: my_page_url_data?.sortVal ? my_page_url_data?.sortVal : "",
        branchVal: my_page_url_data?.branchVal ? my_page_url_data?.branchVal : "",
        radiusVal: my_page_url_data?.radiusVal ? my_page_url_data?.radiusVal : "",
        excludeVal: my_page_url_data?.excludeVal ? my_page_url_data?.excludeVal : "",
        investmentVal: my_page_url_data?.investmentVal ? my_page_url_data?.investmentVal : false,
    }
}


/**Property Intro */
export const propertyIntro = ({ type, propertyType, areas, minPrice, maxPrice, bedrooms, action, introCopy = false, isMetaTitle = false, mustInclude, furnishing, department, office_department, bedValPlus, radiusVal, investmentVal, propertyTypeArr, minbedVal, maxbedVal }, property_type_list) => {



    areas =  areas ? areas.replace(/"/g, "") : defaultArea;


    let intro = [];
    let property_text = "";
    let property_text_2 = "";
    

    if(office_department === "student"){
        property_text = "student ";
        property_text_2 = "Student ";
    }
    if(office_department === "exceptional"){
        property_text = "exceptional ";
        property_text_2 = "Exceptional ";
    }

    if(investmentVal){
        property_text = "investment ";
        property_text_2 = "Investment ";
    }

    property_text += department === "commercial" ? "commercial property" : "property";
    property_text_2 += department === "commercial" ? "Commercial property" : "Property";

    if(office_department === "new_homes"){
        property_text = "new homes ";
        property_text_2 = "New homes ";
    }

    if(department === "auction"){
        property_text = "auctions"
        property_text_2 = "Auctions"
    }

    if(office_department === "collection"){
        property_text += " collection";
        property_text_2 += " Collection";
    }
    
    if (type === "newdevelopments") {
        property_text = "new developments";
        property_text_2 = "New developments";
    }

    if (furnishing) {
        if(introCopy){
            intro.push(furnishing.replace('part-','semi-'))
            intro.push(property_text);
        } else{
            intro.push(capitalize(furnishing.replace('part-','semi-')))
            intro.push(property_text);
        }
    } else{
        if(introCopy){
            intro.push(property_text);
        } else{
            intro.push(capitalize(property_text_2));
        }
    }
    

    //console.log("introCopy", introCopy, areas) ;

    let replace_area = "";
    let check_area = areas ? areas : defaultArea;



    if (check_area) {
        
        if(check_area.replace(/ /g, '-') === defaultArea_Slug){
            replace_area = defaultArea;
        } else{
            var split_and = check_area.split(" and ")
            //console.log("split_and =>", split_and)
    
            if(split_and?.length > 2){

                replace_area = capitalize(check_area);
            } else{
                replace_area = capitalize(check_area);
            }

                        
        }

        
    }



    if (introCopy) {
    //     if (furnishing) {
    //         intro.push(furnishing)
    //     }

    //   intro.push("property");
        areas = replace_area;
    } else{
        if (type === "newdevelopments") {
            intro = ["New developments"];
      
            if (!areas) {
              intro = ["New Developments"];
              areas = replace_area;
            } else{
              intro = ["New developments"];
            }
        } else{          
            areas = replace_area;
        }

    } 
     
    //console.log("property_type_list intro", property_type_list)
    if(propertyTypeArr?.length > 1){
        intro = [];
        var prop_type = propertyTypeArr.join(" and ")

        if (type === "newdevelopments") {
            intro.push("New "+prop_type.toLowerCase());
        } else{
            
            var prop_type_offc = "";
            if(office_department === "student"){
                prop_type_offc += "student ";
            }
            prop_type_offc += prop_type;

            if(office_department === "collection"){
                prop_type_offc += " collection";
            }
            if(office_department === "exceptional"){
                prop_type_offc += " exceptional";
            }

            if (introCopy) {
                //intro.push(prop_type_offc.toLowerCase());
                intro.push("properties")
            } else{
                //intro.push(capitalize(prop_type_offc));
                intro.push("Properties")
            } 
        }

    } else{
        if (propertyType) {
            intro = [];
      
            var filter_prop_type = property_type_list?.length > 0 && property_type_list.filter(item => item.value === propertyType);
      
            //console.log("filter_prop_type", filter_prop_type, filter_prop_type?.length, propertyType);
      
            if(filter_prop_type?.length > 0){
              var prop_type = filter_prop_type[0].label.replace(/\//g,' and ')
              
              if (type === "newdevelopments") {
                  intro.push("New "+prop_type.toLowerCase());
              } else{
                  
                  var prop_type_offc = "";
                  if(office_department === "student"){
                      prop_type_offc += "student ";
                  }
                  prop_type_offc += prop_type;
      
                  if(office_department === "collection"){
                      prop_type_offc += " collection";
                  }
      
                  if (introCopy) {
                      intro.push(prop_type_offc.toLowerCase());
                  } else{
                      intro.push(capitalize(prop_type_offc));
                  } 
              }
             
            } else{
              if (type === "newdevelopments") {
                  intro.push("New "+propertyType);
              } else{
                  intro.push(capitalize(propertyType));
              }
            }

            if(propertyType === "terraced" || propertyType === "semi-detached" || propertyType === "detached"){
                intro.push("houses")
            }
            
      
          //   if(property_type_list?.length > 0){
          //     property_type_list.filter(item => item.value === propertyType)
          //   }
            //intro.push(capitalize(propertyType));
          }
    }


    if (action) {
      intro.push(action)
    }
    if (areas) {

        
        // var split_and = areas.split(" and ");
        // console.log("split_and", split_and.length, areas)

        // if(split_and.length >= 2){
        //     intro.push(`in ${areas}`)
        // } else{
        //     //intro.push(`in ${startCase(areas)}`)

        //     let check_number =  areas.match(/(\d+)/)
        //     if(check_number?.length > 0){
        //         intro.push(`in ${areas.toUpperCase()}`)
        //     } else{
        //         intro.push(`in ${toCapitalize(areas)}`)
        //     }
        // }
      
      intro.push(`in ${areas}`)
    }

    
    // if (isMetaTitle) {
    //   intro.push(`| ${capitalize(areas)} homes`)
    //   if (action) {
    //     intro.push((action))
    //   }
    // }
  
    // if (introCopy || isMetaTitle) {
      // return join(intro, ' ');
    // }
  
    // if (bedrooms) {
    //     if(parseInt(bedrooms) === 0){
    //         if(department === "commercial"){

    //         }else{
    //             intro.push(`with studios`)
    //         }
    //     } else{
    //         if(bedValPlus){
    //             if(bedValPlus === "true"){
    //                 if (parseInt(bedrooms) > 1) {
    //                     intro.push(`with more than ${bedrooms} bedrooms`)
    //                 } else{
    //                     intro.push(`with more than ${bedrooms} bedrooms`)
    //                 }
    //             } else{
    //                 if (parseInt(bedrooms) > 1) {
    //                     intro.push(`with ${bedrooms} bedrooms`)
    //                 } else{
    //                     intro.push(`with ${bedrooms} bedroom`)
    //                 }
    //             }
    //         } else{
    //             if (parseInt(bedrooms) > 1) {
    //                 intro.push(`with more than ${bedrooms} bedrooms`)
    //             } else{
    //                 intro.push(`with more than ${bedrooms} bedrooms`)
    //             }
    //         }
    //         // if (parseInt(bedrooms) > 1) {
    //         //     intro.push(`with more than ${bedrooms} bedrooms`)
    //         //   } else {
    //         //     intro.push(`with more than ${bedrooms} bedrooms`)
    //         // }
    //     }
      
    // }

    if(minbedVal || maxbedVal){
        intro.push(getBedStr(minbedVal, maxbedVal));
    }
  
    if (minPrice || maxPrice) {
      intro.push(getPriceStr(minPrice, maxPrice));
    }

    if (mustInclude?.length > 0) {
        var mustInclude_arr = ""

        //console.log("mustInclude_arr", mustInclude[mustInclude.length - 2]);

        mustInclude?.map((item, i) => {

            if(item === mustInclude[mustInclude.length - 2]){
                mustInclude_arr += item.replace(/-/g,' ')+" and "
            } else{
                mustInclude_arr += item.replace(/-/g,' ')+", "
            }
            
        })

        intro.push(" with " +  mustInclude_arr.slice(0, -2))
    }

    if (radiusVal) {
        if (parseInt(radiusVal, 10) > 1) {
          intro.push(` within ${radiusVal} Miles`)
        } else {
          intro.push(` within ${radiusVal} Mile`)
        }
      }

    
    return join(intro, ' ');
}